import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DOCUMENT, effect, inject, Renderer2 } from '@angular/core';
import { AuthService } from '@mbs-reseller/app/services/auth';

@Component({
  selector: 'mbs-reseller-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class FooterComponent {
  private auth = inject(AuthService);
  private document = inject<Document>(DOCUMENT);
  private renderer = inject(Renderer2);

  protected isShowFooter = computed(() => this.auth.isAuthenticated());

  constructor() {
    effect(() => {
      this.renderer[this.isShowFooter() ? 'addClass' : 'removeClass'](this.document.body, '-showFooter');
    });
  }
}
